import { headingStyle } from "../theme/default";

export default function EmptyModal(props: {
	id: string;
	title: string | JSX.Element;
	message: string | JSX.Element;
	buttons: JSX.Element;
}) {
	const { id, title, message, buttons } = props;
	return (
		<div
			className="modal fade"
			id={id}
			tabIndex={-1}
			role="dialog"
			aria-labelledby="exampleModalLabel"
			aria-hidden="true"
		>
			<div className="modal-dialog" role="document">
				<div className="modal-content">
					<div className="modal-header">
						<h5 className="modal-title" style={headingStyle}>
							{title}
						</h5>
						<button
							className="close"
							type="button"
							data-dismiss="modal"
							aria-label="Close"
						>
							<span aria-hidden="true">×</span>
						</button>
					</div>
					<div className="modal-body">{message}</div>
					<div className="modal-footer">{buttons}</div>
				</div>
			</div>
		</div>
	);
}
